"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withStripeInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lib_1 = require("../../lib");
function withStripeInput() {
    return (WrappedComponent) => {
        const InputGroup = ({ onFocus, onBlur, onChange, onReady, className, label, autoFocus, error, value, }) => {
            const input = (0, react_1.useRef)(null);
            const setInput = (0, react_1.useCallback)((ref) => {
                input.current = ref;
            }, [input]);
            const refProps = {
                ref: setInput,
                elementRef: setInput,
            };
            const [isFocused, setIsFocused] = (0, react_1.useState)(false);
            const [hasValue, setHasValue] = (0, react_1.useState)(false);
            const handleFocus = (0, react_1.useCallback)((e) => {
                setIsFocused(true);
                if (onFocus)
                    onFocus(e);
            }, [setIsFocused]);
            const handleBlur = (0, react_1.useCallback)((e) => {
                setIsFocused(false);
                if (onBlur)
                    onBlur(e);
            }, [setIsFocused, onBlur]);
            const handleChange = (0, react_1.useCallback)((e) => {
                if (e["empty"] !== undefined) {
                    const event = e;
                    setHasValue(!event.empty);
                    if (onChange)
                        onChange(event);
                }
                else {
                    const event = e;
                    const value = event.target.value;
                    setHasValue(value !== undefined && value !== "");
                    if (onChange)
                        onChange(value);
                }
            }, [setHasValue, onChange]);
            const handleReady = (0, react_1.useCallback)((el) => {
                if (autoFocus)
                    el.focus();
                if (onReady)
                    onReady(el);
            }, [autoFocus]);
            (0, react_1.useEffect)(() => {
                if (input.current && !input.current["_element"]) {
                }
            }, []);
            const handleLabelClick = (0, react_1.useCallback)(() => {
                if (input.current && input.current.tagName === "INPUT") {
                    input.current.focus();
                }
            }, [input]);
            const style = {
                color: "#42547a",
                fontSize: "16px",
                lineHeight: "16px",
                flex: "1",
                base: {
                    color: "#42547a",
                    fontSize: "16px",
                    lineHeight: "16px",
                    margin: "0",
                    padding: "0",
                },
            };
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)(className, "stripe-input-group flex__flex--1") }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)("flex__flex--1", (0, lib_1.bem)("input-group", (0, lib_1.use)(isFocused, "--is-focussed"), (0, lib_1.use)(hasValue, "--is-filled"), "--2_5")) }, { children: [label && ((0, jsx_runtime_1.jsx)("label", Object.assign({ className: (0, lib_1.bem)("input-group__label", "--2_5", (0, lib_1.use)(isFocused, "--is-focussed"), (0, lib_1.use)(hasValue, "--is-filled")), onClick: handleLabelClick }, { children: label }), void 0)), (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, refProps, { value: value, className: (0, lib_1.bem)("input-group__input", "--2_5", (0, lib_1.use)(isFocused, "--is-focussed"), (0, lib_1.use)(hasValue, "--is-filled")), placeholder: "", onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, onReady: handleReady, style: style }), void 0)] }), void 0), error && ((0, jsx_runtime_1.jsx)("p", Object.assign({ className: "type--alert type--1 type--default" }, { children: error }), void 0))] }), void 0));
        };
        InputGroup.displayName = `StripeInput(${WrappedComponent ? "StripeElement" : WrappedComponent.displayName})`;
        return InputGroup;
    };
}
exports.withStripeInput = withStripeInput;
//# sourceMappingURL=withStripeInput.js.map